module.exports = __webpack_public_path__ + "img/expand-menu.f232298d.svg";